<template>
    <shade>
        <div class="shade-chil" ref='shadeccc'>
    <!-- 头部区 -->
    <div>
      <i class="iconfont resource-icon">&#xe7c5;</i>
    <h1 class="resource-title">
        <!-- 标题插槽 -->
        <slot name="title">
            </slot>
        </h1>
    <!-- 搜索框区 -->
        <div class="seek-box">
            <!--  搜索框插槽-->
            <slot name="serch" >
            </slot>
        </div>
    </div>
    <!-- 内容区 -->
    <div>
      <div style="height: 100% border-bottom: 1px solid #ddd">
      <div class="resource" ref="resource">
        <!-- 内容区 -->
        <div
          id="resourceList"
          class="resourceList"
          ref="resourceList"
        >
        <!-- 内容区插槽 -->
        <slot name="contner"></slot>
        </div>
      </div>
    </div>
    </div>
    <!-- 底部区 -->
    <div >
    <slot name="foter">
    </slot>
    </div>
        </div>
    </shade>
</template>

<script>
import shade from "@/components/shade/shade";
import { PopupManager } from 'element-ui/lib/utils/popup'
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "modalCom",

  components: {
    shade,
  },

  props:['height','width'],

  data() {
    return {
    };
  },
  created() {},
  mounted(){
    let shadeccc=this.$refs.shadeccc
    this.$refs.shadeccc.style.zIndex=PopupManager.zIndex
      // this.$refs.center.style.zIndex=PopupManager.zIndex
    if(this.height){
    this.$refs.shadeccc.style.height=this.height+'px'
    this.$refs.resourceList.style.height=this.height-100+'px'
    this.$refs.resource.style.height=this.height-120+'px'
    }
    if(this.width){
    this.$refs.shadeccc.style.width=this.width+'px'
    }
  },
  destroyed(){
    // this.$refs.shadeccc.style.height=680+'px'
    // this.$refs.resourceList.style.height=560+'px'
    // this.$refs.resource.style.height=560+'px'
    // this.$refs.shadeccc.style.width=1050+'px'
  }
};
</script>

<style scoped>

.resource-title {
  position: absolute;
  top: 15px;
  left: 48px;
  font-size: 18px;
  font-family: "微软雅黑";
  color: #303133;
  font-weight: 600;
}
.resource-icon {
  position: relative;
  top: -7px;
  font-size: 27px;
  color: #303133;
  margin-bottom: 20px;
}

.resource-icon:after {
  position: absolute;
  content: "";
  display: block;
  height: 90%;
  width: 0;
  border-left: 3px solid #303133;
  left: -10px;
  top: 2px;
}
.resource {
  /* display: flex; */
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}
.shade-chil {
  width: 1200px;
  height: 680px;
  /* background-color: RGB(249,249,249); */
  border-radius: 12px;
  box-shadow: 4px 4px 12px #888888;
  background-image: linear-gradient(#f9f9f9, #fdfdfd, #f0f0f0, #f3f3f3);

  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
  border-right: 1px solid #888;
  border-bottom: 1px solid #888;
  padding: 20px;
  position: relative;
  z-index: 100;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.shade-chil .listBtn-box {
  position: absolute;
  width: 670px;
  height: 30px;
  line-height: 30px;
  /* border-right: 1px solid #ddd; */
  /* border-left   1px solid #ddd */
  padding-left: 10px;
  top: -37px;
  left: 3px;
  z-index: 1000;
}
.shade-chil .listBtn-box span a {
  color: #303133;
  font-size: 10px;
}

.shade-chil .listBtn-box span i {
  color: #303133;
  font-size: 10px;
}
.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  /* top: 70px; */
  width: 100%;
  /* height 505px */
  /* border-top: 1px solid #ddd; */
  /* border-bottom  1px solid #ddd */
}

.seek-box {
  position: absolute;
  width: 330px;
  height: 40px;
  top: 5px;
  right: 0px;
  z-index: 10;
}
.seek-main {
  width: 80%;
  height: 40px;
  font-size: 14px;
  color: #888;
  border: none;
}
.resource{
  height: 560px;
}
.resourceList {
  width: 100%;
  height: calc( 100% - 0px );
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* align-content: center; */
  align-content: flex-start;
  /* position: relative; */
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/modalCom/modal.vue